import script from "./forecastPage.vue?vue&type=script&setup=true&lang=js"
export * from "./forecastPage.vue?vue&type=script&setup=true&lang=js"

import "./forecastPage.vue?vue&type=style&index=0&id=0952bf98&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0952bf98"]])

export default __exports__